// extracted by mini-css-extract-plugin
export var active = "_c1-c";
export var compactArrow = "_c1-5";
export var container = "_c1-0";
export var dot = "_c1-b";
export var dotContainer = "_c1-a";
export var hoverArrowButton = "_c1-7";
export var hoverArrowContainer = "_c1-6";
export var leftHoverArrowContainer = "_c1-8 _c1-6";
export var rightHoverArrowContainer = "_c1-9 _c1-6";
export var slide = "_c1-4";
export var sliderContainer = "_c1-1";
export var sliderContainerVisibleOverflow = "_c1-2";
export var sliderOverflow = "_c1-3";
export var vignetteBoth = "_c1-f";
export var vignetteLeft = "_c1-e";
export var vignetteRight = "_c1-d";